import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import './ProjectRow.scss';

export class ProjectRow extends BaseComponent {

  constructor(props) {
    super(props);
    this.handleNavigateToProject = this.handleNavigateToProject.bind(this);
    this.handleGoToProjectList = this.handleGoToProjectList.bind(this);
  }

  handleNavigateToProject() {
    if (this.props.gotoProject) {
      this.props.gotoProject(this.props.project);
    }
  }

  /** Opens the project in the main app project view (/projects/:id) — separate from POR row navigation when provided. */
  handleGoToProjectList(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.gotoProjectList) {
      this.props.gotoProjectList(this.props.project);
    }
  }

  render() {
    const { project, gotoProjectList } = this.props;
    const listTooltip = `Go to Projects Tab: ${project.name || 'Project'}`;

    return (
      <div className={'project-row' + (gotoProjectList ? ' project-row--with-list-link' : '')}>
        <div className="project-underline" onClick={this.handleNavigateToProject}>
          <div className="project-icon" />
          <div className="project-name">{project.name}</div>
        </div>
        {gotoProjectList ? (
          <button
            type="button"
            className="project-row__project-list-link"
            title={listTooltip}
            aria-label={listTooltip}
            onClick={this.handleGoToProjectList}
          >
            <span className="project-row__project-list-icon" aria-hidden="true" />
          </button>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

export default connect(mapStateToProps)(ProjectRow);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORProjectDocuments/AttachmentsTable/ProjectRow/index.js